import 'i18next';
import { IsNotEmpty, MaxLength, MinLength } from 'class-validator';

import { t } from '@app-velocity/i18n';

export class QuestionDto {
  @IsNotEmpty({
    message: t('prototypes:validation.question_cannot_be_empty'),
  })
  @MinLength(3, {
    message: t('prototypes:validation.title_too_short', {
      minLength: 3,
    }),
  })
  @MaxLength(255, {
    message: t('prototypes:validation.title_too_long', {
      maxLength: 255,
    }),
  })
  question = '';
}
